import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import React, { useEffect, useState } from "react";
import { Button } from "rsuite";
import { roleTypeArr, statusArr } from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import AssignOrder from "./AssignOrder";
import { useSelector } from "react-redux";

const OrderBulkAction = ({
  checkedKeys,
  setCheckedKeys,
  onBulkDelete,
  onBulkAssign,
  onExportOrder,
  onValueOrder,
  ...props
}: {
  checkedKeys: any;
  setCheckedKeys: Function;
  onBulkDelete: any;
  onBulkAssign: any;
  onExportOrder: any;
  onValueOrder?: any;
}) => {
  const { t } = useTranslation();
  const selectedCompany = useSelector((state: any) => state.company);
  const [openBulkActionNoSelectionModal, setOpenBulkActionNoSelectionModal] =
    useState(false);
  const [openModalByName, setOpenModalByName] = useState("");
  const [displayAssignOrder, setDisplayAssignOrder] = useState(false);
  const [openExportOrderModal, setOpenExportOrderModal] = useState(false);
  const [openOrderValueModal, setOpenOrderValueModal] = useState(false);
  const [openBulkDeleteModal, setOpenBulkDeleteModal] = useState(false);
  const [bulkActionMessage, setBulkActionMessage] = useState("");
  const [bulkActionTitle, setBulkActionTitle] = useState("");

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    init();
  }, [selectedCompany]);

  function init() {
    try {
      setDisplayAssignOrder(showAssignOrder());
    } catch (error) {
      console.log(error);
    }
  }

  function showAssignOrder() {
    let compId: number = 0;
    if (UtilityServices.getLoggedInUser("user_type") == roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (
      UtilityServices.getLoggedInUser("user_type") == roleTypeArr.backend
    ) {
      compId = selectedCompany.id;
    }
    return compId > 0 ? true : false;
  }

  function bulkDelete() {
    if (checkedKeys.length === 0) {
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenBulkDeleteModal(true);

    setBulkActionMessage(
      t("CONFIRM_ACTION", {
        action: t("DELETE").toLowerCase(),
        entity: t("ORDER").toLowerCase(),
      })
    );
    setBulkActionTitle(
      t("CONFIRM_ACTION_TITLE", {
        action: t("DELETE").toLowerCase(),
      })
    );
  }

  function bulkAssign() {
    if (checkedKeys.length === 0) {
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenModalByName("assign-order");
  }

  return (
    <div className="order-action col-md-8 customer-action mb-hide">
      {UtilityServices.hasPermission("delete-order") && (
        <Button onClick={bulkDelete}>{t("DELETE")}</Button>
      )}
      {displayAssignOrder && UtilityServices.hasPermission("update-order") && (
        <Button onClick={bulkAssign}>
          {t("ASSIGN")} {t("ORDERS")}
        </Button>
      )}
      {UtilityServices.hasPermission("export-order") && (
        <Button onClick={() => setOpenExportOrderModal(true)}>
          {t("EXPORT")}
        </Button>
      )}
      {UtilityServices.hasPermission("view-order") && (
        <Button onClick={() => setOpenOrderValueModal(true)}>
          {t("VIEW")} {t("ORDER")} {t("VALUE")}
        </Button>
      )}
      <AlertModal
        open={openBulkActionNoSelectionModal}
        handleClose={(e: any) => {
          if (e) {
            setOpenBulkActionNoSelectionModal(false);
          }
        }}
        displayText={t("PLEASE_SELECT_RECORD_TO_ACTION")}
        modalTitle={t("PLEASE_SELECT")}
        cancelButton={false}
      />
      <AlertModal
        open={openBulkDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onBulkDelete();
            setOpenBulkDeleteModal(false);
          } else {
            setOpenBulkDeleteModal(false);
          }
        }}
        displayText={bulkActionMessage}
        modalTitle={bulkActionTitle}
      />
      <AlertModal
        open={openExportOrderModal}
        handleClose={(e: any) => {
          if (e == true) {
            onExportOrder();
            setOpenExportOrderModal(false);
          } else {
            setOpenExportOrderModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION_ALL", {
          action: t("EXPORT").toLowerCase(),
          entity: t("ORDER").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("EXPORT").toLowerCase(),
        })}
      />
      <AlertModal
        open={openOrderValueModal}
        handleClose={(e: any) => {
          if (e == true) {
            onValueOrder();
            setOpenOrderValueModal(false);
          } else {
            setOpenOrderValueModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION_ALL", {
          action:
            t("SEE").toLowerCase() +
            " " +
            t("VALUE").toLowerCase() +
            " " +
            t("OF").toLowerCase(),
          entity: t("ORDERS").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("ORDER").toLowerCase() + " " + t("VALUE").toLowerCase(),
        })}
      />
      {openModalByName === "assign-order" && (
        <AssignOrder
          openModal={openModalByName === "assign-order" ? true : false}
          setOpenModal={setOpenModalByName}
          onAssignOrder={onBulkAssign}
        />
      )}
    </div>
  );
};

export default OrderBulkAction;
